import Obstacle from './Obstacle';

export default class Enemy extends Obstacle {
  constructor({ game, player, values, road, spikes }) {
    super({
      game,
      player,
      values,
      road,
      name: 'enemy',
      spikes,
    });
    this._chance = 0.009;
    this._deltaSpeed = 1;
  }
  _move() {
    super._move();
    this._collidedShield();
  }
}



// WEBPACK FOOTER //
// ./src/js/Enemy.js